import React, { useState } from "react";
import { withTranslation } from "react-i18next";

import logolight from "../../assets/images/logo-light.png";
import logodark from "../../assets/images/logo-dark.png";

import { Container, Row, Col, Card, CardBody } from "reactstrap";
import { Link } from "react-router-dom";
import { PLATFORM_NAME } from "../../CommonData/Data/constant";
import callApi from "../../helpers/CallApi";
import { forgetPassword } from "../../helpers/API";
import { toast } from "react-toastify";

const RecoverPassword = ({ t }) => {
  // Dynamic document title using translation
  document.title = `${t("recoverPassword.page.title")} | ${PLATFORM_NAME}`;

  const [email, setEmail] = useState("");

  const handleRecoverPassword = () => {
    if (!email) return;

    callApi({
      callback: forgetPassword,
      payload: [{ email }],
      onSuccess: ({ message }) => {
        toast.success(message);
      },
      onError: (error) => {
        toast.error(error);
      },
    });
  };

  return (
    <React.Fragment>
      <div className="bg-pattern" style={{ height: "100vh" }}>
        <div className="bg-overlay"></div>
        <div className="account-pages pt-5">
          <Container>
            <Row className="justify-content-center">
              <Col lg={6} md={8} xl={4}>
                <Card className="mt-5">
                  <CardBody className="p-4">
                    <div className="">
                      <div className="text-center">
                        <Link to="/" className="">
                          <img
                            src={logodark}
                            alt=""
                            height="24"
                            className="auth-logo logo-dark mx-auto"
                          />
                          <img
                            src={logolight}
                            alt=""
                            height="24"
                            className="auth-logo logo-light mx-auto"
                          />
                        </Link>
                      </div>
                      <h4 className="font-size-18 text-muted mt-2 text-center">
                        {t("recoverPassword.heading")}
                      </h4>
                      <p className="mb-5 text-center">
                        {t("recoverPassword.description", {
                          platformName: PLATFORM_NAME,
                        })}
                      </p>
                      <form className="form-horizontal" action="#">
                        <Row>
                          <Col md={12}>
                            <div className="alert alert-warning alert-dismissible">
                              <div
                                dangerouslySetInnerHTML={{
                                  __html: t("recoverPassword.alert.message"),
                                }}
                              />
                            </div>

                            <div className="mt-4">
                              <label className="form-label" htmlFor="useremail">
                                {t("recoverPassword.labels.email")}
                              </label>
                              <input
                                type="email"
                                className="form-control"
                                id="useremail"
                                placeholder={t(
                                  "recoverPassword.placeholders.enterEmail"
                                )}
                                onChange={(e) => setEmail(e.target.value)}
                                value={email}
                              />
                            </div>
                            <div
                              className="d-grid mt-4"
                              onClick={handleRecoverPassword}
                            >
                              <span
                                className="btn btn-primary waves-effect waves-light"
                                type="submit"
                              >
                                {t("recoverPassword.buttons.sendEmail")}
                              </span>
                            </div>
                          </Col>
                        </Row>
                      </form>
                    </div>
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </Container>
        </div>
      </div>
    </React.Fragment>
  );
};

export default withTranslation()(RecoverPassword);
